import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const formSubmitEmbedEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-business-form-submit-embed-entrypoint" */ './src'),
	),
	getPreloadProps: () => ({}),
});
